/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';
import AppUtils from "../../../../utils/AppUtils";


interface IWeekViewProps {
    startDate: number;
    endDate: number;
    setDates: (startDate: number, endDate: number) => void;
}

export const WeekView: React.FC<IWeekViewProps> = (props: IWeekViewProps) => {

    const { startDate, endDate, setDates } = props;

    const epochInWeek: number = (7 * 24 * 60 * 60 * 1000);

    const handlePreviousWeek = () => {
        setDates((startDate - epochInWeek), (endDate - epochInWeek))
    }

    const handleNextWeek = () => {
        setDates((startDate + epochInWeek), (endDate + epochInWeek))
    }

    const dateList = AppUtils.getListOfDays(startDate, endDate);

    return (
        <React.Fragment>
            <th css={styles.arrowHeader}> <img src="/images/back-frwd.svg" onClick={handlePreviousWeek} /></th>
            {
                dateList && dateList.map((date, index) => {
                    return (<th key={date.startEpoch} css={styles.datesLabel}><div>{date.display}</div>
                        <div>{date.dayShortForm}</div></th>)
                })
            }
            <th css={styles.arrowHeader}> <img src="/images/back-frwd.svg" css={styles.frwdIconStyle} onClick={handleNextWeek} /></th>
        </React.Fragment>
    )
}